<div class="document-scoreboard-menu-bar">
  <div class="back-container">
    <app-score-button 
            (click)="onPreviousClick()"
            (keypress)="onPreviousClick()"
            class="scoreboard-button__left__{{isPreviousButtonEnabled ? 'enabled' : 'disabled'}} document-scoreboard__previous-button"
            [dataTestId]="'scoreboard-previous'"
            type="primary"
            [isDisabled]="!isPreviousButtonEnabled">
            <img src="{{isPreviousButtonEnabled ? '/assets/icons/navigate_before-icon.svg':'/assets/icons/navigate_before-disabled-icon.svg'}}" alt="Advance to previous document" class="img__{{isNextButtonEnabled ? 'enabled' : 'disabled'}}" />
            Previous
    </app-score-button>
  </div>
  <div class="document-scoreboard-menu-bar__content">
    <ng-content></ng-content>
  </div>
  <div class="next-container">
    <app-score-button 
            (click)="onNextClick()"
            (keypress)="onNextClick()"
            class="scoreboard-button__right__{{isNextButtonEnabled ? 'enabled' : 'disabled'}} document-scoreboard__next-button"
            [dataTestId]="'scoreboard-next'"
            type="primary"
            [isDisabled]="!isNextButtonEnabled">Next
            <img src="{{isNextButtonEnabled ? '/assets/icons/navigate_next-icon.svg':'/assets/icons/navigate_next-disabled-icon.svg'}}" alt="Advance to next document" class="img__{{isNextButtonEnabled ? 'enabled' : 'disabled'}}" />
    </app-score-button>
  </div>
</div>
